import { sumBy } from 'lodash'
import accounting from 'accounting'

export default {
  computed: {
    /**
     * The tonnage completed of a job.
     *
     * This is live updated by looking at all the loads within the job instead of by the
     * returned tonnage completed of the job.
     *
     * @return string
     */
    tonnageCompleted () {
      let completed = sumBy(this.loads, load => {
        if (load.status === 'cancelled') {
          return 0
        }

        if (load.weighbridge === null || load.weighbridge.status !== 'approved') {
          return 0
        }

        return load.weighbridge.total_tonnage
      })

      return `${completed.toFixed(2)}t`
    },

    /**
     * The progress completed percentage of the job.
     *
     * Weighbridge verified (tonnage_completed) vs job quantity as percentage.
     *
     * @return integer
     */
    progressCompletedPercentage () {
      if (this.job.status === 'declined' || this.job.status === 'pending') {
        return 0
      } else if (this.job.status === 'completed') {
        return 100
      }

      let completed = (sumBy(this.loads, load => {
        if (load.status === 'cancelled') {
          return 0
        }

        if (load.weighbridge === null || load.weighbridge.status !== 'approved') {
          return 0
        }

        return load.weighbridge.total_tonnage
      }) / this.job.quantity) * 100

      if (completed > 100) {
        completed = 100
      }

      return accounting.formatNumber(completed, 2)
    },

    /**
     * The progress assigned percentage of the job.
     *
     * @return integer
     */
    progressAssignedPercentage () {
      if (this.job.status === 'declined' || this.job.status === 'pending') {
        return 0
      } else if (this.job.status === 'completed') {
        return 100
      }

      let assigned = ((sumBy(this.loads, load => {
        if (load.status === 'cancelled') {
          return 0
        }

        if (load.weighbridge === null || load.weighbridge.status !== 'approved') {
          return load.size
        }

        return load.weighbridge.total_tonnage
      }) / this.job.quantity) * 100)

      if (assigned > 100) {
        assigned = 100
      }

      return accounting.formatNumber(assigned, 2)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/jobs/job-progress-helpers.js